/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-workspace-widget-host',
  template: `
    <adn-stats-widget *ngIf="widgetDirective === 'adnStatsWidget'" [widgetType]="widget"></adn-stats-widget>
    <adn-bar-chart-widget *ngIf="widgetDirective === 'adnBarChartWidget'" [widgetType]="widget"></adn-bar-chart-widget>
    <adn-tree-map-widget *ngIf="widgetDirective === 'adnTreeMapWidget'" [widgetType]="widget"></adn-tree-map-widget>
    <adn-line-item-list-widget *ngIf="widgetDirective === 'adnLineItemList'" [widgetType]="widget"></adn-line-item-list-widget>
    <adn-order-list-widget *ngIf="widgetDirective === 'adnOrderList'" [widgetType]="widget"></adn-order-list-widget>
    <adn-advertiser-earnings-widget *ngIf="widgetDirective === 'adnAdvertiserEarningsList'" [widgetType]="widget"></adn-advertiser-earnings-widget>
    <adn-html-insertion-widget *ngIf="widgetDirective === 'adnHtmlInsertion'" [widgetType]="widget"></adn-html-insertion-widget>
    <adn-external-iframe-widget *ngIf="widgetDirective === 'adnWidgetIframe'" [widgetType]="widget"></adn-external-iframe-widget>
  `
})
export class WorkspaceWidgetHostComponent {
  @Input() widget: any;

  get widgetDirective(): string {
    return this.widget?.systemDefined?.widget;
  }
}
